import * as Astronomy from "astronomy-engine";
import type { Vec3 } from "./coords";
import { lagrange6 } from "./dwarf";
import table from "../data/halley-table.json";

interface Segment { startJDTDB: number; stepDays: number; n: number; xyz: number[] }
const SEGMENTS = (table as unknown as { segments: Segment[] }).segments;

/** 优先用细网格（近日点前后 ±300 天，12 小时步长），边缘各留 3 个节点给插值；否则用 10 天粗网格。 */
function pick(jd: number): { seg: Segment; i0: number; u: number } {
  for (let k = SEGMENTS.length - 1; k >= 1; k--) {
    const s = SEGMENTS[k]!, pos = (jd - s.startJDTDB) / s.stepDays;
    if (pos >= 3 && pos <= s.n - 4) return { seg: s, i0: Math.floor(pos), u: pos - Math.floor(pos) };
  }
  const s = SEGMENTS[0]!, pos = (jd - s.startJDTDB) / s.stepDays, i0 = Math.floor(pos);
  if (i0 - 2 < 0 || i0 + 3 > s.n - 1) throw new RangeError("halley: date outside table coverage");
  return { seg: s, i0, u: pos - i0 };
}

/**
 * 哈雷彗星日心位置（黄道 J2000，AU）。来自 Horizons 星历表（含 1910/1986/2061 近日点的细网格）。
 * 二体传播在 2061 年近日点附近误差超过 100°，所以不用。
 */
export function halleyHelioEcliptic(date: Date): Vec3 {
  const jdTT = Astronomy.MakeTime(date).tt + 2451545.0;
  const { seg, i0, u } = pick(jdTT);
  const at = (c: number) => lagrange6(seg.xyz, (k) => (i0 + k) * 3 + c, u);
  return { x: at(0), y: at(1), z: at(2) };
}
